import { useCallback, useEffect, useState } from "react";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import FieldList from "../Component/FieldList";
// sm:640 md:768 lg:1024 xl1280 2xl:1536
function Home() {
  const [fields, setFields] = useState([]);
  const [tech, setTech] = useState([]);

  const populateData = useCallback(() => {
    setFields([
      {
        title: "Frontend Development",
        description:
          "Bringing concepts to life with responsive, modern, and user-friendly interfaces using the latest frameworks.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
            ></path>
          </svg>
        ),
      },
      {
        title: "Backend & API Development",
        description:
          "Building scalable and secure server-side logic and robust APIs to handle complex application data.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h-4"
            ></path>
          </svg>
        ),
      },
      {
        title: "Database Management",
        description:
          "Designing and optimizing databases. Also managing schema migration, querying, and data handling.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 7v10m-4-7h20M4 17h16a2 2 0 002-2V9a2 2 0 00-2-2H4a2 2 0 00-2 2v6a2 2 0 002 2z"
            ></path>
          </svg>
        ),
      },
      {
        title: "Software Development",
        description:
          "Designing robust, maintainable, and scalable software systems, focusing on design patterns, testing, and continuous integration/delivery.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 17h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
        ),
      },
      {
        title: "Android Development",
        description:
          "Crafting native mobile applications for Android, focusing on performance, user experience, scalability, and maintainability.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
            ></path>
          </svg>
        ),
      },
      {
        title: "Game Development",
        description:
          "Developing engaging interactive experiences, specializing in game logic, core gameplay, and utilizing modern game engines like Unity.",
        icon: () => (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 10l4.55 4.55a1.5 1.5 0 010 2.12L15 21l-3.55-3.55a1.5 1.5 0 01-2.12 0L6 21l-4.55-4.55a1.5 1.5 0 010-2.12L6 10l3.55 3.55a1.5 1.5 0 002.12 0L15 10z"
            ></path>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 2l4 4-4 4-4-4 4-4z"
            ></path>
          </svg>
        ),
      },
    ]);
    setTech([
      "React / Next.js",
      "Node.js / Express",
      "Laravel",
      "Kotlin",
      "C#",
    ]);
  }, []);

  useEffect(() => {
    populateData();
  }, [populateData]);

  return (
    <div>
      <Header />
      <section className="bg-lightGray min-h-screen">
        {/* Hero Section */}
        <div className="container mx-auto px-4 py-16 sm:py-24 md:py-32 flex flex-col items-center justify-center text-center">
          <div className="max-w-4xl">
            <p className="text-gray-600 font-medium text-lg mb-4 sm:text-xl md:text-2xl">
              It's great to see you here!
            </p>
            <h1 className="text-gray-900 font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-tight">
              Hello, I'm{" "}
              <span className="text-crimson">Mohammad Rifal Ali Fahri</span>
            </h1>

            <p className="text-gray-700 font-medium text-xl mt-4 sm:text-2xl md:text-3xl">
              Currently working as a{" "}
              <span className="font-bold">Programmer & Developer</span>.
            </p>
            <p className="text-gray-500 text-md mt-2 sm:text-lg">
              I hope we have a chance to collaborate on a great project.
            </p>

            <div className="mt-8 sm:mt-12">
              <p className="text-crimson font-medium text-lg mb-4">
                Feel free to discover my work & journey
              </p>
              <button className="bg-crimson text-white font-semibold tracking-wide px-8 py-3 rounded-lg shadow-lg transition duration-300 ease-in-out hover:bg-blue-600 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-crimson focus:ring-opacity-50">
                <a href="/work" className="block">
                  Discover My Work
                </a>
              </button>
            </div>
          </div>
        </div>

        {/* Explored Fields Section */}
        <div className="bg-white py-16 sm:py-24">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12 sm:text-4xl">
              My Explored{" "}
              <span className="text-crimson">Fields & Expertise</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {fields && fields.map((item) => <FieldList item={item} />)}
            </div>
          </div>
        </div>

        {/* --- Favorite Tech Section --- */}
        <div className="py-16 sm:py-24 bg-lightGray">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12 sm:text-4xl">
              My <span className="text-crimson">Favorite Tech Stack</span>
            </h2>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              {tech &&
                tech.map((name) => (
                  <span className="px-4 py-2 bg-gray-200 text-gray-800 font-medium rounded-full text-lg shadow-md hover:bg-gray-300 transition duration-150">
                    {name}
                  </span>
                ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Home;
